/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { FaAirbnb, FaBooking } from "react-icons/fa";
import "../../assets/scss/core/sections/_singleproject.scss";
import Button from "../elements/Button";
import dataa from "../../data/projects.json"; 
import upcomingData from "../../data/upcomingprojects.json";
import { AiOutlineFilePdf } from "react-icons/ai";
import { AiOutlineDownload } from "react-icons/ai";
import i18next, { t } from "i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import "react-image-gallery/styles/scss/image-gallery.scss";
import { useTranslation } from "react-i18next";
import ImageGallery from "react-image-gallery";

function SingleProject() {
  useTranslation([]);
  const [singleProject, setSingleProject] = useState({}); 
  const [images, setImages] = useState([]);
  const { name } = useParams();
  const history = useHistory();
  AOS.init({ 
    once: false,
  });
  useEffect(() => {
    const findProject = () => {
      let allProjects = [];
      if (i18next.language === "en") {
        allProjects = [...dataa.projectsEN, ...upcomingData.projectsEN];
      } else {
        allProjects = [...dataa.projectsDE, ...upcomingData.projectsDE];
      }
      const newProject = allProjects.find(
        (project) => project.link === name
      );
      if (newProject) {
        setSingleProject(newProject);
        setImages(newProject.images || []);
      }
    };
    findProject();
  }, [name, i18next.language]);
  if (!singleProject.name && !singleProject.id) return null;
  return (
    <section className="container pt-5">
      <article
        key={singleProject.id}
        className="article pt-5"
        data-aos="fade-up"
        data-aos-duration="2300"
      >
        <div>
          <h2 className="h2">{singleProject.name}</h2>
          <p className="p">{singleProject.desc}</p>
          {singleProject.bookingLinks && (
            <div className="booking-buttons-container mb-4">
              <a 
                href={singleProject.bookingLinks.airbnb} 
                target="_blank" 
                rel="noreferrer" 
                className="booking-btn airbnb"
              >
                <svg viewBox="0 0 32 32" className="btn-icon-svg" fill="currentColor">
                  <path d="M16 1c2.008 0 3.463.963 4.751 3.269l.533 1.025c1.954 3.83 6.114 12.54 7.1 14.836l.145.353c.667 1.591.91 2.472.96 3.396l.01.415.001.228c0 4.062-2.877 6.478-6.357 6.478-2.224 0-4.556-1.258-6.709-3.386l-.257-.26-.172-.179h-.011l-.176.185c-2.044 2.1-4.392 3.42-6.72 3.42-3.481 0-6.358-2.416-6.358-6.478 0-1.141.225-2.127.755-3.615l.169-.452c1.155-2.859 6.22-13.685 7.211-15.746l.144-.316C12.537 1.963 13.992 1 16 1zm0 2c-1.232 0-2.046.539-3.03 2.3l-.127.283c-.927 1.928-5.932 12.636-7.1 15.526l-.161.43c-.456 1.282-.625 2.022-.625 2.983 0 2.979 2.012 4.478 4.358 4.478 1.625 0 3.376-.893 5.163-2.733l.255-.27.2-.218c.245-.268.665-.268.91 0l.201.218.257.272c1.784 1.836 3.535 2.729 5.161 2.729 2.345 0 4.357-1.499 4.357-4.478 0-.814-.146-1.523-.556-2.603l-.161-.413c-.968-2.259-5.111-10.938-7.075-14.793l-.532-1.022C18.046 3.539 17.232 3 16 3zm0 11a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z"/>
                </svg>
                {t("Go to airbnb")}
              </a>
              <a 
                href={singleProject.bookingLinks.booking} 
                target="_blank" 
                rel="noreferrer" 
                className="booking-btn booking-com"
              >
                <svg viewBox="0 0 24 24" className="btn-icon-svg" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 21l18 0" /><path d="M5 21v-14l8 -3v17" /><path d="M13 21v-9l8 -3v12" /><path d="M9 9h0" /><path d="M9 12h0" /><path d="M9 15h0" /><path d="M17 12h0" /><path d="M17 15h0" />
                </svg>
                {t("Go to booking.com")}
              </a>
            </div>
          )}
          <p className="p">{singleProject.description1}</p>
          <p className="p">{singleProject.description2}</p>
          <p className="desc">
            <span style={{ fontWeight: "700" }}>{singleProject.desc2bold}</span>
            <span style={{ fontWeight: "700" }}>{singleProject.fertig}</span>
            <span style={{ fontWeight: "500" }}>{singleProject.februar}</span>
          </p>
          <p style={{ marginBottom: "0px" }} className="desc">
            <span style={{ fontWeight: "700" }}>{singleProject.desc3bold}</span>
            {singleProject.desc3}
          </p>
          {singleProject.desc3 && <p className="desc">{singleProject.isAvailable}</p>}
          <span style={{ fontWeight: "700" }}>{singleProject.desJahr}</span><br />
                      {singleProject.desc2}<br />
          <p className="desc">{singleProject.desc9}</p>
          <ImageGallery thumbnailPosition="bottom" items={images} />
        </div>
        {singleProject.plan?.map((data, index) => (
          <div className="pt-3" key={index}>
            {/* <Button>
              <a href={data.href} className="pdffile" download={data.download}>
                <span className="icon"><AiOutlineFilePdf /></span>
                {t("DownloadPlan")}
                <span className="icon"><AiOutlineDownload /></span>
              </a>
            </Button> */}
            <div style={{ display: 'flex', flexDirection: 'column', marginTop:'10px' }}>
              <h4 style={{ fontWeight: 'bold', color:'#CFB261' }}>{data.plan}</h4>
            </div>
          </div>
        ))}
        <div className="butoni">
          {singleProject.available && (
            <HashLink smooth to="/#contact" style={{ background: 'black', color: '#CFB261', height: '60px', borderRadius: '3px', padding: '10px', display: 'flex', alignItems: 'center', width: '190px', fontSize: '17px', fontWeight: '700', justifyContent: 'center', marginBottom: '10px'}}>
              {t("Kontaktieren")}
            </HashLink>
          )}
          <Button onClick={history.goBack} color="primary">
            {t("GoBack")}
          </Button>
        </div>
      </article>
    </section>
  );
}

export default SingleProject;
